export enum GridAlignment {
  Left = 'align-left',
  Center = 'align-center',
  Right = 'align-right',
}
